"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var base_1 = require("../../base");
/**
 * ## Numeric Reader
 * Provides an implementation for a reader for
 * [[NumericIndividual]].
 * @typeparam I Type of the generated individual, which extends [[NumericIndividual]].
 */


var NumericReader =
/** @class */
function (_super) {
  __extends(NumericReader, _super);

  function NumericReader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Tokenize a string into several
   * tokens. the tokens are separated by one
   * or more whitespace characters.
   * @param definition of the individual.
   * @return the tokenized string.
   */


  NumericReader.prototype.tokenize = function (definition) {
    return definition.split(/\s+/).filter(Boolean);
  };

  return NumericReader;
}(base_1.BaseIndividualReader);

exports.default = NumericReader;